import {DocumentService} from "./DocumentService";
import {AppEntities} from "../../config/entities";
import {PaymentRequestPriorityTypeEnum} from "../../components/Pages/Documents/PaymentRequests/dtos/Enum/PaymentRequestPriority";
import { CreatePaymentRequestsDto } from "src/components/Pages/Documents/PaymentRequests/dtos/CreatePaymentRequestsDto";
import { PaymentRequestOperationTypeEnum } from "src/components/Pages/Documents/PaymentRequests/dtos/PaymentRequestOperationTypeEnum";

export class PaymentRequestsService extends DocumentService {
    async createBasedAtVendorInvoice(id:string){
        const sourceDocumentDto = await AppEntities.VendorInvoices.getDataService().Get(id);
        const targetDocumentDto:CreatePaymentRequestsDto = {...sourceDocumentDto};

        targetDocumentDto.baseDocumentAtId = id;
        
        targetDocumentDto.documentDate = new Date();
        targetDocumentDto.paymentDate = new Date();
        targetDocumentDto.documentNumber = '';
        targetDocumentDto.paymentRequestPriority = PaymentRequestPriorityTypeEnum.Average;
        
        targetDocumentDto.operationType = PaymentRequestOperationTypeEnum.PaymentToTheSupplier;
        targetDocumentDto.companyId = sourceDocumentDto.companyId;
        targetDocumentDto.currencyId = sourceDocumentDto.currencyId;
        targetDocumentDto.vendorCustomerId = sourceDocumentDto.vendorCustomerId;
        targetDocumentDto.contractId = sourceDocumentDto.contractId;
        
        targetDocumentDto.amount = sourceDocumentDto.totalAmount;
        
        return targetDocumentDto;
    };
    
    async Clone(id: string) {
        const newObject = await this.Get(id);
        const clonedObject = { ...newObject };
        console.log('clonedObject is', clonedObject)
        return clonedObject;
    }
}